module.exports = __webpack_public_path__ + "img/Google__G__Logo.8d59b934.svg";